import axios from 'axios';
import api from '../../../utils/api';

export default {
  async getMediaChannels(_, page) {
    const { data } = await axios(api.mediaChannels.get(page));
    return data;
  },
};
